import React, { useState } from 'react';

export default function DenialModal({ onConfirm, onCancel }) {
  const [reason, setReason] = useState('');

  const handleSubmit = (e) => {
    e.preventDefault();
    if (!reason.trim()) return;
    onConfirm(reason.trim());
  };

  return (
    <div className="modal-overlay" onClick={onCancel}>
      <div className="modal" onClick={(e) => e.stopPropagation()}>
        <h3>Deny This Request</h3>
        <p style={{ color: 'var(--text-secondary)', marginBottom: '1rem', fontSize: '0.9375rem' }}>
          Please provide a reason. This will be visible to the congregation.
        </p>
        <form onSubmit={handleSubmit}>
          <textarea
            className="form-textarea"
            value={reason}
            onChange={(e) => setReason(e.target.value)}
            placeholder="Reason for denial…"
            rows={3}
            autoFocus
            required
          />
          <div className="modal-actions">
            <button type="button" className="btn btn-secondary" onClick={onCancel}>Cancel</button>
            <button type="submit" className="btn btn-danger" disabled={!reason.trim()}>Deny Request</button>
          </div>
        </form>
      </div>
    </div>
  );
}
